import React, { useState } from 'react';
import { handleLoggingIn } from '../../common/atoms/Login/login.util';
import { useAuthContext } from '../../providers/auth-provider';
import LoginPage from '../../common/atoms/Login/LoginPage';
import appStrings from '../../common/app_strings';
import { openInBrowser } from '../../helpers/broswer';

const LOGIN_STRINGS = appStrings.login.unified;

const environmentUrl = import.meta.env.VITE_API_BASEURL || '';
const GROW_URL = import.meta.env.VITE_GROW_URL;
const GROW_SIGNUP_URL = GROW_URL ? `${GROW_URL}/signup` : null;

const UnifiedLoginContainer = () => {
  const { afterLogin } = useAuthContext();

  const [errorMessage, setErrorMessage] = useState(null);

  const doAfterLogin = async (loginResponse) => {
    try {
      await afterLogin(loginResponse);
    } catch {
      setErrorMessage('Error getting user information');
    }
  };

  const onLogin = async (phone, email, password) => {
    await handleLoggingIn({
      phone,
      email,
      password,
      setErrorMessage,
      environmentUrl,
      afterLogin: doAfterLogin,
    });
  };

  const handleRegisterOnClick = async () => {
    if (!GROW_SIGNUP_URL) {
      console.error('VITE_GROW_URL is not set; cannot open signup');
      setErrorMessage(LOGIN_STRINGS.error.login.genericError);
      return;
    }
    try {
      await openInBrowser(GROW_SIGNUP_URL);
    } catch (e) {
      console.error(e);
      setErrorMessage(LOGIN_STRINGS.error.login.genericError);
    }
  };

  return <LoginPage title={LOGIN_STRINGS.title} handleLoggingIn={onLogin} handleSigningUp={handleRegisterOnClick} errorMessage={errorMessage} />;
};

export default UnifiedLoginContainer;
